import styled, { keyframes } from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";
import { DEFAULT_ANIMATION_SPEED, ZIndex } from "../../constants";
import { colorMixin } from "../../helpers";

export const zoomInAnimation = keyframes`
  0% {
    transform: scale(0.95) ;
    transform-origin: center;
    opacity: 0;
  }
  100% {
    transform: scale(1) ;
    transform-origin: center;
    opacity: 1;
  }
`;

export const zoomOutAnimation = keyframes`
  0% {
    transform: scale(1);
    transform-origin: center;
    opacity: 1;
  }
  100% {
    transform: scale(0.95);
    transform-origin: center;
    opacity: 0;
  }
`;

export const opacityInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const opacityOutAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const DialogContentWrapper = styled(Dialog.Content)`
    z-index: ${ZIndex.MODAL};

    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const DialogContent = styled.div`
    z-index: ${ZIndex.MODAL};
    display: block;
    padding: 16px;
    max-width: calc(100vw - 72px);

    background: ${colorMixin("background-primary-base")};
    border-radius: 8px;
    max-height: calc(100vh - 20px);
    overflow-y: auto;

    box-shadow: 0 12px 24px ${colorMixin("primary-800", 0.1)};

    animation-name: ${zoomOutAnimation};
    animation-duration: ${DEFAULT_ANIMATION_SPEED}ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;

    [data-state="open"] & {
        animation-name: ${zoomInAnimation};
    }
`;

export const DialogOverlay = styled(Dialog.Overlay)`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${ZIndex.MODAL};
    overflow: auto;

    background: rgba(52, 64, 84, 0.7);
    backdrop-filter: blur(8px);

    animation-name: ${opacityOutAnimation};
    animation-duration: ${DEFAULT_ANIMATION_SPEED}ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;

    &[data-state="open"] {
        animation-name: ${opacityInAnimation};
    }
`;
